import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Check, ArrowRight } from 'lucide-react';

const FEATURES = [
  'Modular & Flexible Designs',
  'Premium Quality Materials',
  'Quick Installation',
  'Customizable Colors',
  '10+ Years Legacy (Est. 2014)'
];

export function ClassicHero() {
  return (
    <section className="relative h-screen overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_modular-store-1/artifacts/ts4s2zsv_Banner%203-Picsart-AiImageEnhancer-Picsart-AiImageEnhancer.png"
          alt="Modular Office Furniture - Workstations and Privacy Booths"
          className="w-full h-full object-cover object-center brightness-100"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/40 via-white/20 to-transparent" />
      </div>

      <div className="relative h-full flex items-center">
        <div className="container mx-auto px-8">
          <div className="max-w-3xl">
            {/* Tagline */}
            <div className="mb-6 animate-fade-in">
              <div className="inline-block bg-primary backdrop-blur-sm px-6 py-3 rounded-lg shadow-2xl">
                <p className="text-2xl md:text-3xl font-black text-white tracking-tight">
                  KHOLO<span className="text-yellow-400">,</span> JODO<span className="text-yellow-400">,</span> AUR LAGALO
                </p>
                <p className="text-sm text-white/90 mt-1 font-medium">Open it, Join it, Set it up.</p>
              </div>
            </div>
            
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black uppercase mb-6 leading-tight text-foreground drop-shadow-sm animate-fade-in-up">
              Moving In or
              <br />
              <span className="text-primary">Expanding Your Team?</span>
            </h1>
            
            <p className="text-xl md:text-2xl text-foreground/90 mb-8 leading-relaxed font-medium">
              Focus on your growth; we'll handle the floor plan.
            </p>

            <div className="flex flex-wrap gap-4 mb-8">
              {FEATURES.map((feature, index) => (
                <div key={index} className="flex items-center gap-2 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg border border-primary/20">
                  <Check className="w-4 h-4 text-primary" />
                  <span className="text-sm font-semibold text-foreground">{feature}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-4">
              <Link to="/contact">
                <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full uppercase tracking-wider font-bold px-10 py-7 text-lg shadow-2xl hover:shadow-primary/50 transition-all duration-300 hover:scale-105">
                  Share Your Premises Dimensions
                  <ArrowRight className="ml-2 w-6 h-6" />
                </Button>
              </Link>
              <Link to="/products">
                <Button variant="outline" className="bg-white/90 backdrop-blur-sm border-2 border-white text-foreground hover:bg-white rounded-full uppercase tracking-wider font-bold px-10 py-7 text-lg shadow-xl transition-all duration-300 hover:scale-105">
                  EXPLORE PRODUCTS
                </Button>
              </Link>
              <a 
                href="https://wa.me/919594685818?text=Hi%2C%20I%20need%20a%20bulk%20quote%20for%20office%20furniture" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Button className="bg-[#25D366] hover:bg-[#128C7E] text-white rounded-full uppercase tracking-wider font-bold px-10 py-7 text-lg shadow-xl transition-all duration-300 hover:scale-105">
                  <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  GET BULK QUOTE
                </Button>
              </a>
              <a 
                href="#ezeefit-promise"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('ezeefit-promise')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <Button variant="outline" className="bg-slate-900/90 backdrop-blur-sm border-2 border-slate-700 text-white hover:bg-slate-800 rounded-full uppercase tracking-wider font-bold px-10 py-7 text-lg shadow-xl transition-all duration-300 hover:scale-105">
                  <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  THE EZEEFIT PROMISE
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
